export enum SystemSettingKey {
  RegistrationFee = 'registrationFee',
  GoodAndServiceTax = 'goodAndServiceTax',
  Deposit = 'deposit',
  NonRefundable = 'nonRefundable',
  WaivePeriod = 'waivePeriod',
  GovernmentTax = 'governmentTax',
  NonGST = 'nonGST',
}
